import {StyledMonthGrid} from '@/components/commons/calendar/month-grid/style'
import {MonthGridProps} from 'react-day-picker'

export const MonthGrid = ({isRange, ...props}: MonthGridProps & {isRange: boolean}) => {
    return <StyledMonthGrid {...props} $isRange={isRange} />
}
